var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "kyqwoiz4na"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 37284",
    transform: "translate(0 .312)",
    style: {
      fill: "none"
    },
    d: "M0 0h67v67H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 38296"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 38295",
    transform: "translate(0 -.312)",
    style: {
      clipPath: "url(#kyqwoiz4na)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 16270",
    d: "M32.573.036A33.509 33.509 0 0 0 1.009 31.213a33.888 33.888 0 0 0 5.175 20.615 4 4 0 0 1-.489 4.95L.981 61.559A3.375 3.375 0 0 0 3.33 67.31h31.146v-.009a33.428 33.428 0 0 0 32.835-33.645A33.4 33.4 0 0 0 32.573.036",
    transform: "translate(0 -.409)",
    style: {
      fill: "#ffc11a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 16271",
    d: "M45.206 27.028a2.147 2.147 0 0 0-1.929 2.242c0 .062-.147.227-.421.237h-.326V28.3a12.348 12.348 0 0 0-10.197-12.2v-2.28a2.04 2.04 0 1 0-4.08 0v2.28a12.349 12.349 0 0 0-10.2 12.2v1.209h-.469c-.282 0-.432-.17-.432-.344a2.118 2.118 0 0 0-1.925-2.134 2.2 2.2 0 0 0-1.563.563 2.125 2.125 0 0 0-.649 1.534 4.549 4.549 0 0 0 4.513 4.584h.525v9.066a2.039 2.039 0 1 0 4.078 0v-9.071h16.322v9.066a2.04 2.04 0 1 0 4.08 0V33.7a4.737 4.737 0 0 0 1.211-.079 4.528 4.528 0 0 0 3.676-4.493 2.088 2.088 0 0 0-2.073-2.1h-.138m-6.76 2.472H22.134v-1.2a8.159 8.159 0 1 1 16.316 0z",
    transform: "translate(3.439 2.903)",
    style: {
      fill: "#fff"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.94d6c6cc275c6f5ed0129be8778eb44c.svg";
export { ForwardRef as ReactComponent };